module.exports = __webpack_public_path__ + "img/icon1.c091482d.png";